import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";
import { sendEmailNotification } from "../bills/httpCalls";
const initialState = {
  items: [],
  selectedForPurchase: [],
  selectedForReturn: [],
  selected: [],
  next_page_token: "",
  totalStockValue: "",
  totalStockSaleValue: "",
  loading: false,
  error: "",
};

// export const getItems = createAsyncThunk("items/fetchItems", () => {
//   const startTime = performance.now(); 

//   return Repo.default({
//     request: {
//       method: "getInventory",
//       data: {
//         company_code: localStorage.getItem("companyCode"),
//         next_page_token: initialState.next_page_token,
//       },
//     },
//   })
//     .then(({ data }) =>  data.response.data)
//     .catch((err) => console.log(err));
// });

export const getItems = createAsyncThunk("items/fetchItems", async () => {
  const startTime = performance.now(); // Record the start time

  try {
    const { data } = await Repo.default({
      request: {
        method: "getInventory",
        data: {
          company_code: localStorage.getItem("companyCode"),
          next_page_token: initialState.next_page_token,
        },
      },
    });

    const endTime = performance.now(); // Record the end time
    const responseTime = endTime - startTime; // Calculate response time
    console.log("Response Time:", responseTime);

    // Check if response time exceeds 20 seconds
    if (responseTime > 20000) { // 20000 milliseconds = 20 seconds
      await sendEmailNotification("getInventory"); // Trigger email notification
      // toast.success("Email notification sent successfully!");
    }

    return data.response.data; // Return the data
  } catch (error) {
    console.error("Failed to fetch items or send email notification:", error.message);
    // toast.error("An error occurred while fetching items!");
    throw error; // Re-throw the error for handling in calling code
  }
});





export const itemsSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    editItem: (state, action) => {
      const { index, value, key } = action.payload;
      state.items[index][key] = value;
    },
    editSearchedItem: (state, action) => {
      let { item, key, value } = action.payload;
      let found = state.items.find((i) => i._id === item._id);
      if (found) {
        found[key] = value;
        // found.selected = item.selected;
      } else {
        let copyItem = JSON.parse(JSON.stringify(item));
        copyItem.selected = true;
        state.items.unshift(copyItem);
      }
    },
    updateSearchedItem: (state, action) => {
      let { _id, value } = action.payload;
      let found = state.items.find((i) => i._id === _id);
      if (found) {
        found.saleQuantity = value;
      } else {
        let copyItem = JSON.parse(JSON.stringify(item));
        copyItem.saleQuantity = value;
        state.items.unshift(copyItem);
      }
    },
    editSelectedItem: (state, action) => {
      const { index, value } = action.payload;
      state.selectForTransfer[index].quantity = value;
    },
    updateItem: (state, action) => {
      let date = Math.floor(Date.now() / 1000);
      let item = action.payload;
      let found = state.items.findIndex((i) => i._id == item._id);
      if (found || found == 0) {
        state.items[found] = action.payload;
        state.items[found].modified_at = date;
      } else {
        state.items.push(action.payload);
      }
    },
    unselectItems: (state, action) => {
      state.items.forEach((item) => {
        item.selected = false;
      });
    },

    saleItem: (state, action) => {
      action.payload.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          found.quantity = item.quantity;
        }
      });
    },
    discountAdded: (state, action) => {
      action.payload.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          found.discount = item.discount;
        }
      });
    },
    saleQuantity: (state, action) => {
      let date = Math.floor(Date.now() / 1000);
      let items = action.payload;
      console.log('itemsmm', items)
      items.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          if (found.boxes) {
            found.boxes -= item.boxes;
          }
          if (found.weightType) {
            found.weight =
              parseFloat(found.weight) - parseFloat(item.saleQuantity);
          } else {
            found.quantity =
              parseFloat(found.quantity) - parseFloat(item.saleQuantity);
            if (found.batchNo) {
              found.batchNo = null;
              found.batchQty = null;
              let entryFound = found.batchNumber.find(
                (i) => i.batchNumber == item.batchNo
              );
              if (entryFound) {
                entryFound.quantity -= parseInt(item.saleQuantity);
              }
            }
          }
          found.modified_at = date;
        }
      });
    },
    unSaleItems: (state, action) => {
      action.payload.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          found.quantity = item.quantity;
        }
      });
    },
    unPurchaseItems: (state, action) => {
      action.payload.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          found.quantity = item.quantity;
        }
      });
    },
    deleteItem: (state, action) => {
      let { index } = action.payload;
      state.items.splice(index, 1);
    },
    addItem: (state, action) => {
      let { item, index } = action.payload;
      state.items.splice(index, 0, item);
    },
    selectItem: (state, action) => {
      state.selected.unshift(action.payload);
    },
    unSelectItem: (state, action) => {
      const { _id } = action.payload;
      let index = state.selected.findIndex((item) => item._id == _id);
      state.selected.splice(index, 1);
    },
    unSelectForPurchase: (state, action) => {
      const { _id } = action.payload;
      let index = state.selectedForPurchase.findIndex(
        (item) => item._id == _id
      );
      state.selectedForPurchase.splice(index, 1);
    },
    selectForPurchase: (state, action) => {
      state.selectedForPurchase = state.selected;
      state.selected = [];
    },
    editSelectForPurchase: (state, action) => {
      const { _id, price } = action.payload;
      let index = state.selectedForPurchase.findIndex(
        (item) => item._id == _id
      );
      state.selectedForPurchase[index].companyPrice = price;
    },
    addToSelectForPurchase: (state, action) => {
      const items = action.payload;
      let copy = current(state.selectedForPurchase);
      let all = [...copy, ...items];
      const uniqueItems = new Set();
      const filtered = all.filter((el) => {
        const duplicate = uniqueItems.has(el._id);
        uniqueItems.add(el._id);
        return !duplicate;
      });
      state.selectedForPurchase = filtered;
    },
    purchasedSelection: (state, action) => {
      const { index, value, key } = action.payload;
      state.selectedForPurchase[index][key] = value;
    },
    remSelectedPurchase: (state, action) => {
      state.selectedForPurchase = [];
    },
    purchaseItems: (state, action) => {
      let items = action.payload;
      items.forEach((item) => {
        let found = state.items.find((i) => i._id == item._id);
        if (found) {
          if (found.weightType) {
            found.weight =
              parseFloat(found.weight) + parseFloat(item.purchaseQuantity);
          } else {
            found.quantity =
              parseFloat(found.quantity) + parseFloat(item.purchaseQuantity);
            if (item.batchNo) {
              let entryFound = found.batchNumber.find(
                (i) => i.batchNumber == item.batchNo
              );
              if (entryFound) {
                entryFound.quantity =
                  parseInt(entryFound.quantity) +
                  parseInt(item.purchaseQuantity);
              }
            }
          }
        }
      });
    },

    selectForReturn: (state, action) => {
      state.selectedForReturn = state.selected;
      state.selected = [];
    },
    selectForTransfer: (state, action) => {
      state.selectForTransfer = state.selected;
    },
    remSelectedReturn: (state, action) => {
      state.selectedForReturn = [];
    },
    editSelectedReturn: (state, action) => {
      const { index, value, key } = action.payload;
      state.selectedForReturn[index][key] = value;
    },
    remSelRetun: (state, action) => {
      const i = action.payload;
      state.selectedForReturn.splice(i, 1);
    },
    returnItem: (state, action) => {
      const { _id, qty } = action.payload;
      let found = state.items.find((item) => item._id == _id);
      if (found) {
        if (found.weightType) {
          found.weight = parseInt(found.weight) + parseInt(qty);
        } else {
          found.quantity = parseInt(found.quantity) + parseInt(qty);
        }
      }
    },
    clearSelected: (state, action) => {
      state.selected = [];
    },
    clearInventory: (state, action) => {
      state.items = [];
    },
    removeBulkItems: (state, action) => {
      let item = action.payload;
      let index = state.items.findIndex((i) => i._id == item._id);
      state.items.splice(index, 1);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getItems.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getItems.fulfilled, (state, action) => {
      const { items, next_page_token, totalStockValue, totalStockSaleValue } = action.payload;
      state.loading = false;
      state.items = items;
      state.totalStockSaleValue = totalStockSaleValue;
      state.totalStockValue = totalStockValue;
      state.next_page_token = next_page_token || "";
      state.error = "";
    });
    builder.addCase(getItems.rejected, (state, action) => {
      state.loading = false;
      state.items = [];
      state.next_page_token = "";
      state.totalStockSaleValue= "";
      state.totalStockValue = "";
      state.error = action.error.message;
    });
  },
});

export const {
  updateSearchedItem,
  editSelectForPurchase,
  addToSelectForPurchase,
  discountAdded,
  removeBulkItems,
  editSearchedItem,
  clearInventory,
  editItem,
  unselectItems,
  saleItem,
  saleQuantity,
  unSaleItems,
  updateItem,
  deleteItem,
  addItem,
  selectItem,
  unSelectItem,
  selectForPurchase,
  unSelectForPurchase,
  purchasedSelection,
  remSelectedPurchase,
  purchaseItems,
  unPurchaseItems,
  selectForReturn,
  remSelectedReturn,
  remSelRetun,
  editSelectedReturn,
  returnItem,
  editSelectedItem,
  clearSelected,
  selectForTransfer,
} = itemsSlice.actions;

export default itemsSlice.reducer;
